import {useCallback, useEffect, useState} from "react";

export const useAccordion = (sections: { id: string; defaultOpen: boolean }[]) => {
    const [openedSection, setOpenedSection] = useState(() =>
        Object.fromEntries(
            sections.map(section => [section.id, section.defaultOpen])
        )
    );

    const toggleSection = useCallback((id: string) => {
        setOpenedSection(prev => ({
            ...prev,
            [id]: !prev[id],
        }));
    }, []);

    return {
        openedSection,
        toggleSection,
    };
};
